import { render, staticRenderFns } from "./AgreementExpirationBlock.vue?vue&type=template&id=37b59c07&scoped=true"
import script from "./AgreementExpirationBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./AgreementExpirationBlock.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AgreementExpirationBlock.vue?vue&type=style&index=0&id=37b59c07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b59c07",
  null
  
)

export default component.exports